<template>
  <div class="dropdown-input"
       :class="brandClass">
    <b-form-group :id="`${id}DropdownGroup`"
                  :label="label"
                  :label-for="`${id}Dropdown`">
      <b-form-select :id="`${id}Dropdown`"
                     :aria-describedby="errorIds"
                     :aria-labelledby="`${id}DropdownGroup`"
                     :disabled="disabled"
                     :state="showError"
                     :options="options"
                     v-model="modelValue"
                     v-bind="$attrs"
                     v-on="$listeners">
      </b-form-select>
      <slot></slot>
    </b-form-group>
  </div>
</template>

<script>
import Router from '../../../utility/routerUtil'

export default {
  name: 'dropdown-input',

  props: {
    id: {
      type: [String],
      default: ''
    },

    label: {
      type: [String],
      default: 'Label'
    },

    hasError: {
      type: [Boolean],
      default: null
    },

    errorIds: {
      type: [String],
      default: ''
    },

    value: {
      type: [String, Boolean, Number],
      default: ''
    },

    options: {
      type: [Array],
      default: () => []
    },

    disabled: {
      type: [Boolean],
      default: false
    }
  },

  data () {
    return {
      brandClass: Router.getCurrentRouteBrandClass(this.$route)
    }
  },

  computed: {
    showError () {
      return this.hasError === true ? false : null
    },

    modelValue: {
      get () {
        return this.value
      },

      set (value) {
        this.$emit('input', value)
        this.$emit('change', value)
      }
    }
  }
}
</script>

<style scoped lang="scss">
@use '../../../assets/styles/colors';

::v-deep label {
  margin-bottom: 0.125rem;
  font-size: 14px;
}

::v-deep .form-group {
  margin-bottom: 0;
}

::v-deep .custom-select {
  background: url("data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9IjEwIiB2aWV3Qm94PSIwIDAgMTAgMTAiIHdpZHRoPSIxMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJtNSAwIDUgMTBoLTEweiIgZmlsbD0iIzAwNTI5YiIgZmlsbC1ydWxlPSJldmVub2RkIiB0cmFuc2Zvcm09Im1hdHJpeCgxIDAgMCAtMSAwIDEwKSIvPjwvc3ZnPgo=") no-repeat right 0.75rem center;
  background-size: 0.625rem 0.625rem;
  border: 1px solid #c4c4c4;
}

::v-deep .custom-select.is-invalid {
  background: none;
  border: 1px solid colors.$red-1;
}

::v-deep .custom-select:disabled {
  background: colors.$gray-200;
  border: #c4c4c4 solid 1px;
}

::v-deep .custom-select:focus {
  outline-offset: 3px;
  box-shadow: none;
}

.c1l ::v-deep .custom-select:focus {
  outline: colors.$c1l--orange-1 solid 3px;
}

.ccc ::v-deep .custom-select:focus {
  outline: colors.$ccc--purple-1 solid 3px;
}

.ccf ::v-deep .custom-select:focus {
  outline: colors.$ccf--orange-1 solid 3px;
}

.chs ::v-deep .custom-select:focus {
  outline: colors.$chs--green-3 solid 3px;
}

.cic ::v-deep .custom-select:focus {
  outline: colors.$cic--green-2 solid 3px;
}

.esm ::v-deep .custom-select:focus {
  outline: colors.$esm--orange-1 solid 3px;
}

.inl ::v-deep .custom-select:focus {
  outline: colors.$inl--yellow-1 solid 3px;
}

.tmx ::v-deep .custom-select:focus {
  outline: colors.$tmx--blue-2 solid 3px;
}
</style>
